import { environment } from '../../../environments/environment';

export const MVP_DEMO_OFFLINE = environment.mvpDemoOffline;
